// EWM-243a: analytics consent gate. EWM-577: default everyone to accepted.
//
// Single source of truth for "may we fire analytics?".
//
// EWM-577 — the cookie consent banner was removed and all users now default to
// accepted. With no `cookie_consent` cookie (the common case now that nothing
// writes it) this returns true, so analytics fire for everyone. A previously
// stored explicit `'declined'` choice is still respected.
//
// SSR-safe: returns false on the server (no document) so events never fire
// during SSR; the client-side trackers (GTM, Algolia Insights, GA4 dataLayer)
// are the only consumers.

const CONSENT_COOKIE = 'cookie_consent';
const DECLINED = 'declined';

export const hasAnalyticsConsent = (): boolean => {
  if (typeof document === 'undefined') return false;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${CONSENT_COOKIE}=([^;]+)`));
  // Default (no cookie) → accepted; only an explicit prior `declined` opts out.
  return match ? decodeURIComponent(match[1]) !== DECLINED : true;
};
